export default __webpack_public_path__ + "static/media/ding.7c7cbde5.mp3";